import Container from '@components/global/Container';
import Button from '@components/ui/Button';
import MarkdownCopy from '../MarkdownCopy';
import { useLocale } from '@hooks/useLocale';
import styles from './CopyWithCta.module.scss';

interface CtaStackProps {
  primary: any;
  locale?: string;
}

const CopyWithCta = ({ primary }: CtaStackProps) => {
  const locale = useLocale();
  return (
    <div className={styles.container}>
      <Container>
        {primary?.copy && <MarkdownCopy text={primary?.copy?.[0]?.text} />}
        <div className={styles.container}>
          {primary?.cta_text && (
            <Button
              variant={primary.cta_variant}
              label={primary?.cta_text}
              href={`/${locale}/${primary?.cta_link}`}
              size="large"
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default CopyWithCta;
